<span [ngClass]="completeClass"></span>
